<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconImageError',
  svgType: 'fill',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-image-error', 'type-fill'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path d="M9.075 4a.7.7 0 0 1 .095 1.394l-.095.006H3.9a.5.5 0 0 0-.492.41L3.4 5.9v11.769q0 .116.048.214l3.273-3.241a3.7 3.7 0 0 1 2.38-1.064l.224-.007h.487a.7.7 0 0 1 .095 1.394l-.095.006h-.487a2.3 2.3 0 0 0-1.47.531l-.149.135-2.557 2.532h7.032c.91-1.279 1.357-2.21 1.357-2.712 0-.192-.071-.453-.223-.822l-.151-.343-.418-.866-.163-.346-.128-.291c-.168-.401-.23-.656-.241-.95l-.002-.1c0-.29.03-.497.153-.808l.096-.225.204-.423.445-.872.124-.259.098-.228.042-.109c.108-.289.162-.53.162-.733 0-.664-.366-1.626-1.119-2.853a.7.7 0 0 1-.247-.531c0-.354.263-.647.605-.694l.095-.006h6.8a1.9 1.9 0 0 1 1.894 1.752l.006.148v11.769a1.9 1.9 0 0 1-1.752 1.894l-.148.006H3.896a1.9 1.9 0 0 1-.614-.101 1.9 1.9 0 0 1-1.28-1.65l-.006-.148V5.899a1.9 1.9 0 0 1 1.752-1.894l.148-.006h5.175zm5.863 4.084c0 .392-.088.791-.251 1.225a7 7 0 0 1-.287.656l-.511 1.006-.104.217-.076.172-.028.072-.04.122-.013.052-.013.092-.001.042q0 .065.018.15l.034.126.025.074.067.173.043.101.168.37.368.761c.41.855.603 1.407.603 1.963 0 .708-.359 1.597-1.067 2.711l5.802.001a.5.5 0 0 0 .492-.41l.008-.09V5.901a.5.5 0 0 0-.41-.492l-.09-.008h-5.548c.539 1.035.813 1.924.813 2.684zm-8.744-.679c.715 0 1.294.564 1.294 1.259s-.579 1.259-1.294 1.259S4.9 9.359 4.9 8.664s.579-1.259 1.294-1.259"/>
    </template>
  </svg>
</template>